module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Term")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTerm),
      expression: "selectedTerm"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedTerm = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getMeetings]
    }
  }, _vm._l((_vm.terms), function(term) {
    return _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v("\n                \t\t" + _vm._s(term.name) + "\n                \t")])
  }))]), _vm._v(" "), (_vm.groups) ? _c('div', _vm._l((_vm.groups), function(meetings, groupId) {
    return _c('div', [_c('h4', {
      staticClass: "cursor-pointer",
      on: {
        "click": function($event) {
          _vm.selectedGroup === groupId ? _vm.selectedGroup = null : _vm.selectedGroup = groupId
        }
      }
    }, [_vm._v("\n            \t\t\t" + _vm._s(_vm.determineGroupLabel(meetings[0])) + "\n\t\t\t\t\t\t"), (_vm.selectedGroup === groupId) ? _c('i', {
      staticClass: "fa fa-caret-down"
    }) : _c('i', {
      staticClass: "fa fa-caret-right"
    })]), _vm._v(" "), (_vm.selectedGroup === groupId) ? _c('div', [_c('table', {
      staticClass: "table table-striped table-bordered"
    }, [_vm._m(0, true), _vm._v(" "), _c('tbody', _vm._l((meetings), function(meeting) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.getWeek(meeting.startTime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("shortDate")(meeting.startTime)))]), _vm._v(" "), _c('td', [(meeting.zoom_report && meeting.zoom_report.participants) ? _c('span', [_vm._v(_vm._s(_vm.unique(meeting.zoom_report.participants).map(function (p) { return p.name; }).join(', ')))]) : (meeting.zoom_report) ? _c('span', [_vm._v("0")]) : _c('span', [_vm._v("No Report")])]), _vm._v(" "), _c('td', [(meeting.actualDuration) ? _c('span', [_vm._v(_vm._s(meeting.actualDuration))]) : (meeting.zoom_report && meeting.zoom_report.participants && meeting.zoom_report.participants.length > 0) ? _c('span', [_vm._v("\n            \t\t\t\t\t\t\t\t" + _vm._s(_vm.getDuration(meeting.hostId, meeting.zoom_report.participants)) + "\n            \t\t\t\t\t\t\t")]) : _c('span', [_vm._v("Unknown")]), _vm._v("\n            \t\t\t\t\t\t\tmin\n            \t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('div'), _vm._v(" "), (meeting.archiveUrl) ? _c('a', {
        attrs: {
          "href": meeting.archiveUrl,
          "target": "_blank"
        }
      }, [_vm._v("Link\n                                            "), (meeting.secondaryRecordings && meeting.secondaryRecordings.length > 0) ? _c('span', [_vm._v("\n                                                (\n                                                "), _c('a', {
        staticClass: "recording",
        attrs: {
          "href": meeting.archiveUrl,
          "target": "_blank"
        }
      }, [_vm._v("1")]), _vm._v(" "), _vm._l((meeting.secondaryRecordings), function(recording, index) {
        return _c('span', [_vm._v(",\n                                                    "), _c('a', {
          staticClass: "recording",
          attrs: {
            "href": recording,
            "target": "_blank"
          }
        }, [_vm._v(" " + _vm._s(index + 2) + " ")])])
      }), _vm._v(")\n                                            ")], 2) : _vm._e()]) : _c('span', [_vm._v("No recording")])])])
    })), _vm._v(" "), _c('tfoot')])]) : _vm._e()])
  })) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Week")]), _vm._v(" "), _c('th', [_vm._v("Start Time")]), _vm._v(" "), _c('th', [_vm._v("Participants")]), _vm._v(" "), _c('td', [_vm._v("Duration")]), _vm._v(" "), _c('th', [_vm._v("Recording")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07df03ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/DirectorMeetings.vue
// module id = 1948
// module chunks = 2